import type { SvgIconComponent } from '@mui/icons-material';
import HomeIcon from '@mui/icons-material/HomeOutlined';
import SportsEsportsIcon from '@mui/icons-material/SportsEsportsOutlined';
import RouteIcon from '@mui/icons-material/RouteOutlined';

export interface NavItem {
  /** A key, not a word: the bar re-renders on a language change and a literal would not. */
  key: string;
  to: string;
  icon: SvgIconComponent;
  authenticatedOnly: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  { key: 'nav.dashboard', to: '/', icon: HomeIcon, authenticatedOnly: false },
  { key: 'nav.games', to: '/games', icon: SportsEsportsIcon, authenticatedOnly: false },
  { key: 'nav.playthroughs', to: '/playthroughs', icon: RouteIcon, authenticatedOnly: true },
];

/**
 * Whether a nav entry is the one being looked at.
 *
 * "/" has to match exactly. `startsWith` would make the dashboard the active entry on every
 * page in the app, which is why the old bar excluded it from highlighting altogether and left
 * the home link permanently dull.
 */
export function isActiveRoute(pathname: string, to: string): boolean {
  return to === '/' ? pathname === '/' : pathname.startsWith(to);
}
